import { render, staticRenderFns } from "./AtualizarDadosCadastrais.vue?vue&type=template&id=0ad3e7ea&"
import script from "./AtualizarDadosCadastrais.vue?vue&type=script&lang=js&"
export * from "./AtualizarDadosCadastrais.vue?vue&type=script&lang=js&"
import style0 from "./AtualizarDadosCadastrais.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports